module.exports = __webpack_public_path__ + "img/slider_6.0647cfef.jpg";